module.exports = __webpack_public_path__ + "media/from-the-depths.a5bb5b23.mp3";